import React, { useEffect, useState } from "react";

import {
  faEdit,
  faPlus,
  faRetweet,
  faWarehouse,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";
import Select from "react-select";

import { useSelector } from "react-redux";
import { Pagination } from "../../../Components/Pagination";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { faDropbox } from "@fortawesome/free-brands-svg-icons";

export default function SoanHangPhieuXuatKho() {
  const { proxy, lang } = useSelector((s) => s);
  const navigate = useNavigate();

  const [search, setSearch] = useState({});
  const [refresh, setRefresh] = useState(0);
  const [total, setTotal] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [loadingModal, setLoadingModal] = useState(true);

  const [edits, setEdits] = useState([]);
  const [data, setData] = useState([]);
  const dataPerPage = 10;
  const indexOfLastData = currentPage * dataPerPage;
  const indexOfFirstData = indexOfLastData - dataPerPage;
  const currentData = data || [];
  const [dataCheckbox, setDataCheckbox] = useState([]);

  const headers = [
    { label: "ID", displayFields: "10MPXK" },
    { label: "Phiếu Xuất Kho ERP", displayFields: "maPhieuXuatKhoERP" },
    { label: "LXH/LĐĐNB", displayFields: "LXH" },
    { label: "Phân Phối Từ Kho", displayFields: "ppTuKho" },
    { label: "Ngày Xuất", displayFields: "ngayXuat", isDate: true },
    { label: "Kho Đến", displayFields: "khoden" },
    { label: "Đơn Vị Phân Phối Đến", displayFields: "donViPhanPhoi" },
    { label: "SL Cần Xuất", displayFields: "SLT" },
    { label: "SL Ghi Nhận", displayFields: "slGhiNhan" },
    { label: "SL Gán Thất Bại LPP", displayFields: "SLGTBPP" },
    { label: "SL Gán Thất Bại PXK", displayFields: "SLGTBPXK" },
    { label: "Phương Tiện", displayFields: ["phuongTien", "STTxe", "bsXeGhe"] },
    { label: "Đại Diện Bốc Xếp", displayFields: "daiDienBocXep" },
    { label: "Người Nhận", displayFields: "nguoiNhan" },
    { label: "Ngày Lập Phiếu", displayFields: "ngayLapPhieu", isDate: true },
    { label: "Lý Do Xuất", displayFields: "lyDoXuat" },
    { label: "SL Ghi Nhận", displayFields: "SLGN" },
    { label: "Trạng Thái Chuyến", displayFields: "trangthaichuyen" },
    { label: "Flag", displayFields: "flag" },
    { label: "Người Tạo Phiếu", displayFields: ["MaNT", "nguoiTaoPhieu"] },
    { label: "Nguồn Đồng Bộ", displayFields: "nguonDongBoPXK" },
    { label: "Trạng Thái", displayFields: "TrangThai" },
  ];
  const token = localStorage.getItem("_token");
  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
    setSearch((prev) => ({
      ...prev,
      page: pageNumber,
      limit: dataPerPage,
    }));
  };
  useEffect(() => {
    fetch(proxy() + `/api/PXK/SoanHangPhieuXuatKho`, {
      method: "POST",
      headers: {
        Authorization: token,
        "content-type": "application/json",
      },
      body: JSON.stringify(search),
    })
      .then((res) => res.json())
      .then((res) => {
        const { data, total } = res;
        setTotal(total);
        setData(data);
      })
      .finally(() => setLoading(false));
  }, [search, refresh]);

  const fetchLotData = async (dataLog, lenhxuathang, idLogsPXK, token) => {
    const { masanpham, khocon, delivery_detail_id, tenkho } = dataLog;

    try {
      const response = await fetch(
        `${proxy()}/api/SyncERP/Lot?id=${masanpham}&sub=${khocon}`,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );

      const res = await response.json();
      const { data = [] } = res;

      const soLotsMap = new Map();
      const uniqueViTriSet = new Set();

      data.forEach(({ solot, soluongconton, donvitinh, mavitrikho }) => {
        if (solot) {
          if (soLotsMap.has(solot)) {
            soLotsMap.get(solot).soluongconton += soluongconton;
          } else {
            soLotsMap.set(solot, { solot, soluongconton, donvitinh });
          }
        }

        if (mavitrikho) {
          uniqueViTriSet.add(mavitrikho);
        }
      });

      const danhSachSoLot = Array.from(soLotsMap.values()).map((item) => ({
        label: item.solot,
        value: item.solot,
        ...item,
      }));

      const uniqueViTri = Array.from(uniqueViTriSet);
      const tonLot =
        danhSachSoLot.find(({ value }) => value === dataLog?.solot)
          ?.soluongconton || 0;

      return {
        ...dataLog,
        idLogsPXK,
        solot: {
          label: dataLog?.solot,
          value: dataLog?.solot,
        },
        tenkho,
        vitritrongkho: {
          label: dataLog?.vitritrongkho,
          value: dataLog?.vitritrongkho,
        },
        ton: `${tonLot} Tấn`,
        labelLenhXuatHang: [lenhxuathang, masanpham, delivery_detail_id]
          .filter(Boolean)
          .join("_"),
        danhSachSoLot,
        uniqueViTri,
        danhSachViTriKho: uniqueViTri.map((v) => ({ label: v, value: v })),
      };
    } catch (error) {
      console.error("Error fetching lot data:", error);
      return null;
    }
  };

  const handleModalUpdate = async (item) => {
    setLoadingModal(true);

    const { soanHang = {} } = item || {};
    const { dataLogsPXk = [], lenhxuathang, idLogsPXK } = soanHang;

    const fetchPromises = dataLogsPXk.map((log) =>
      fetchLotData(log, lenhxuathang, idLogsPXK, token)
    );

    const results = await Promise.all(fetchPromises);
    const validResults = results.filter(Boolean);
    if (validResults.length) {
      setEdits(validResults);
    }
    setLoadingModal(false);
  };

  const handleUpdate = () => {
    const mappedUpdates = edits.map((item) => {
      const {
        khocon,
        delivery_detail_id,
        donvitinh,
        solot,
        masanpham,
        vitritrongkho,
        soluongtanxuatthucte,
      } = item;

      return {
        khocon,
        delivery_detail_id,
        donvitinh,
        solot: solot?.value,
        masanpham,
        vitritrongkho: vitritrongkho?.value,
        soluongtanxuatthucte: Number(soluongtanxuatthucte) || 0,
      };
    });

    Swal.fire({
      title: "Đang cập nhật dữ liệu...",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    fetch(proxy() + `/api/SyncERP/PhieuXuatKho/${edits?.[0]?.idLogsPXK}`, {
      method: "PUT",
      headers: {
        Authorization: token,
        "content-type": "application/json",
      },
      body: JSON.stringify(mappedUpdates),
    })
      .then((res) => res.json())
      .then((res) => {
        const { success, message } = res;
        Swal.fire({
          icon: success ? "success" : "error",
          title: success ? lang["success"] : lang["error"],
          text: message,
          showConfirmButton: !success && true,
        });
      })
      .finally(() => setRefresh((prev) => prev + 1));
  };

  const handleSyncData = () => {
    if (!dataCheckbox?.length) {
      Swal.fire({
        icon: "warning",
        title: "Không có dữ liệu để đồng bộ",
        text: "Vui lòng chọn ít nhất một phiếu xuất kho.",
      });
      return;
    }

    Swal.fire({
      title: "Bạn có chắc muốn đồng bộ?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Đồng bộ",
      cancelButtonText: "Huỷ",
    }).then((result) => {
      if (!result.isConfirmed) return;

      Swal.fire({
        title: "Đang đồng bộ dữ liệu...",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      fetch(proxy() + `/api/SyncERP/PhieuXuatKho/Sync`, {
        method: "POST",
        headers: {
          Authorization: token,
          "content-type": "application/json",
        },
        body: JSON.stringify({ DanhSachPXK: dataCheckbox }),
      })
        .then((res) => res.json())
        .then((res) => {
          const { success, message } = res;
          Swal.fire({
            icon: success ? "success" : "error",
            title: success ? lang["success"] : lang["error"],
            text: `ERP phản hồi: ${message}`,
            showConfirmButton: !success,
            timer: success && 1000,
          });
          if (success) {
            setDataCheckbox([]);
            setRefresh((prev) => prev + 1);
          }
        })
        .finally(() => setRefresh((prev) => prev + 1))
        .catch((err) => {
          Swal.fire({
            icon: "error",
            title: "Lỗi",
            text: "Không thể đồng bộ. Vui lòng thử lại.",
          });
          console.error(err);
        });
    });
  };

  return (
    <div className="container-fluid">
      <div className="row" style={{ margin: "5px -15px" }}>
        <div className="col-md-12">
          <div className="white_shd full">
            <div className="tabbar padding_infor_info_p-d-5">
              <div>
                <div
                  className="d-flex align-items-center page-title position-relative mb-0"
                  style={{
                    padding: "8px 0px",
                  }}
                >
                  <span
                    style={{
                      fontSize: "18px",
                      //   color: "rgb(68, 161, 161)",
                      textTransform: "uppercase",
                    }}
                  >
                    Soạn hàng phiếu xuất kho
                  </span>
                  <div className="ml-auto d-flex align-items-center">
                    <img
                      className="icon-add mr-2 pointer"
                      src="/images/sync.webp"
                      alt="#"
                      onClick={handleSyncData}
                      width={27}
                      height={27}
                    />
                    {/* <FontAwesomeIcon
                    icon={faDownload}
                    className="icon-add mr-2 pointer"
                    fontSize={2}
                    onClick={handleSyncData}
                  /> */}
                    {/* <FontAwesomeIcon
                      icon={faDownload}
                      //   onClick={() => buildExportExcelFromLogs(headers, data)}
                      className="icon-add mr-2 pointer"
                      fontSize={2}
                      style={{
                        color: "#269c1b",
                      }}
                      data-toggle="modal"
                      data-target="#modalExport"
                    /> */}
                    <FontAwesomeIcon
                      icon={faRetweet}
                      className="icon-add pointer"
                      fontSize={2}
                      style={{
                        color: "rgb(224, 118, 42)",
                      }}
                      onClick={() => {
                        setRefresh((prev) => prev + 1);
                        setLoading(true);
                        setSearch((prev) => ({
                          page: 0,
                        }));
                        setDataCheckbox([]);
                        // setCurrentPage(1);
                      }}
                    />
                  </div>
                </div>
                <hr
                  style={{
                    border: "1px solid rgb(221, 221, 221)",
                    margin: "0px -11px 5px",
                  }}
                />
                <div className="table-display d-flex">
                  <div className="table-responsive table-custom design-table _table-custom">
                    <table bordered className="align-center" key={refresh}>
                      <thead>
                        <tr>
                          <td></td>
                          <td>#</td>
                          {headers.map((item) => {
                            return <td>{item?.label}</td>;
                          })}
                          <td
                            style={{
                              position: "sticky",
                              right: "-1px",
                              zIndex: 1,
                            }}
                          >
                            Thao Tác
                          </td>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td></td>
                          <td></td>
                          {[
                            "10MPXK",
                            "maPhieuXuatKhoERP",
                            "lenhXuatHangERP",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "1BSPT",
                            "2ĐDBX",
                            "10NN",
                            "",
                            "lyDoXuatPXK",
                            "",
                            "trangthaichuyen",
                            "flag",
                            "136NT",
                            "nguonDongBoPXK",
                            // "28TT.29TT",
                          ].map((item, index) =>
                            item ? (
                              <td key={index}>
                                <input
                                  className="form-control"
                                  type="text"
                                  onChange={(e) => {
                                    const { value } = e.target;
                                    setSearch((prev) => ({
                                      ...prev,
                                      [item]: value.trim(),
                                    }));
                                  }}
                                />
                              </td>
                            ) : (
                              <td></td>
                            )
                          )}
                        </tr>
                        {loading ? (
                          <tr>
                            <td colSpan={99} style={{ textAlign: "center" }}>
                              <img
                                width={40}
                                src="/images/icon/load.gif"
                                alt="Loading..."
                              />
                            </td>
                          </tr>
                        ) : currentData.length ? (
                          currentData.map((item, index) => (
                            <tr key={index}>
                              <td>
                                <input
                                  type="checkbox"
                                  className="form-control pointer"
                                  checked={dataCheckbox.includes(
                                    item?.soanHang?.idLogsPXK
                                  )}
                                  onClick={(e) => {
                                    const { soanHang } = item;
                                    setDataCheckbox((prev) => {
                                      if (e.target.checked) {
                                        return [...prev, soanHang?.idLogsPXK];
                                      } else {
                                        return prev.filter(
                                          (id) => id !== soanHang?.idLogsPXK
                                        );
                                      }
                                    });
                                  }}
                                />
                              </td>
                              <td>{indexOfFirstData + index + 1}</td>
                              {headers.map(
                                (
                                  { displayFields, isDate = false },
                                  headerIndex
                                ) => {
                                  const value = isDate
                                    ? moment(item?.[displayFields])
                                        .utc()
                                        .format("DD/MM/YYYY HH:mm:ss")
                                    : item?.[displayFields];
                                  return (
                                    <td key={headerIndex}>
                                      {Array.isArray(displayFields)
                                        ? displayFields
                                            .map((field, fieldIndex) => [
                                              item?.[field],
                                            ])
                                            .join("\n")
                                        : Array.isArray(value)
                                        ? value.join("\n")
                                        : value}
                                    </td>
                                  );
                                }
                              )}
                              <td
                                style={{
                                  position: "sticky",
                                  right: "-1px",
                                  zIndex: 1,
                                  background: "white",
                                }}
                              >
                                <button
                                  className="btn btn-primary mr-2"
                                  // data-toggle="modal"
                                  // data-target="#modalUpdate"
                                  onClick={() => {
                                    navigate(
                                      `/PhieuXuatKho/${item?.["10MPXK"]}`
                                    );
                                  }}
                                >
                                  <FontAwesomeIcon icon={faEdit} />
                                </button>
                                <button
                                  className="btn btn-warning"
                                  data-toggle="modal"
                                  data-target="#modalUpdate"
                                  onClick={() => handleModalUpdate(item)}
                                >
                                  <FontAwesomeIcon icon={faDropbox} />
                                </button>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <td
                            className="align-center font-weight-bold"
                            colSpan={headers.length + 10}
                          >
                            {lang["not found"]}
                          </td>
                        )}
                      </tbody>
                    </table>
                  </div>
                  <Pagination
                    total={total}
                    itemsPerPage={dataPerPage}
                    currentPage={currentPage}
                    paginate={paginate}
                    lang={lang}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="modal fade"
        id="modalUpdate"
        // tabindex="-1"
        // aria-labelledby="exampleModalLabel"
        // aria-hidden="true"
      >
        <div
          class="modal-dialog"
          style={{
            maxWidth: "80%",
          }}
        >
          <div class="modal-content">
            <div class="modal-header d-flex align-items-center">
              <h5
                className="w-100"
                style={{
                  color: "#44a1a1",
                  fontSize: "18px",
                  padding: "6px 0px",
                }}
              ></h5>
            </div>
            <div
              class="modal-body"
              style={
                {
                  // height: "60vh",
                  // overflow: "auto",
                }
              }
            >
              <div className="container-fluid">
                <div className="row form-row align-items-center">
                  <div className="col-sm-12">
                    <div className="header row mb-3">
                      <div className="col-sm-2">LXH/LĐĐNB</div>
                      <div className="col-sm-2">Số LOT</div>
                      <div className="col-sm-2">Kho Con</div>
                      <div className="col-sm-2">Vị trí</div>
                      <div className="col-sm-2">Tồn</div>
                      <div className="col-sm-2">Số Lượng (Tấn)</div>
                    </div>
                    {loadingModal ? (
                      <div className="w-100 align-center">
                        <img
                          width={40}
                          src="/images/icon/load.gif"
                          alt="Loading..."
                        />
                      </div>
                    ) : (
                      edits.map((edit, index) => {
                        const kho = [edit.khocon, edit.tenkho]
                          .filter(Boolean)
                          .join("_");
                        return (
                          <div
                            className="input row mb-4"
                            key={edit?.idLogsPXK || index}
                          >
                            <div className="col-sm-2">
                              <input
                                className="form-control"
                                type="text"
                                value={edit?.labelLenhXuatHang || ""}
                                readOnly
                              />
                            </div>

                            <div className="col-sm-2">
                              <Select
                                options={edit?.danhSachSoLot || []}
                                value={edit?.solot || null}
                                onChange={(opt) => {
                                  setEdits((prev) =>
                                    prev.map((e, i) =>
                                      i === index
                                        ? {
                                            ...e,
                                            solot: opt,
                                            ton: `${opt?.soluongconton} Tồn`,
                                          }
                                        : e
                                    )
                                  );
                                }}
                                placeholder={lang["select value"]}
                                noOptionsMessage={() => (
                                  <>{lang["not found data"]}</>
                                )}
                              />
                            </div>

                            <div className="col-sm-2">
                              <input
                                className="form-control"
                                type="text"
                                value={kho || ""}
                                readOnly
                              />
                            </div>

                            <div className="col-sm-2">
                              <Select
                                options={edit?.danhSachViTriKho || []}
                                value={edit?.vitritrongkho || null}
                                onChange={(opt) => {
                                  setEdits((prev) =>
                                    prev.map((e, i) =>
                                      i === index
                                        ? { ...e, vitritrongkho: opt }
                                        : e
                                    )
                                  );
                                }}
                                placeholder={lang["select value"]}
                                noOptionsMessage={() => (
                                  <>{lang["not found data"]}</>
                                )}
                              />
                            </div>

                            <div className="col-sm-2">
                              <input
                                className="form-control"
                                type="text"
                                value={edit?.ton || ""}
                                readOnly
                              />
                            </div>

                            <div className="col-sm-2">
                              <input
                                className="form-control"
                                type="number"
                                step="any"
                                min={0}
                                value={edit?.soluongtanxuatthucte || ""}
                                onChange={(e) => {
                                  const { value } = e.target;
                                  setEdits((prev) =>
                                    prev.map((e, i) =>
                                      i === index
                                        ? { ...e, soluongtanxuatthucte: value }
                                        : e
                                    )
                                  );
                                }}
                              />
                            </div>
                          </div>
                        );
                      })
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-primary"
                onClick={handleUpdate}
                disabled={!edits.length && true}
              >
                {lang["btn.update"]}
              </button>
              <button
                type="button"
                class="btn btn-secondary"
                data-dismiss="modal"
              >
                {lang["btn.close"]}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
